import { useAdminContext } from "@/state/adminContext";
import { Fragment, useState } from "react";
import { sitioConfig } from "@/sitio.ts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useRouter } from "@tanstack/react-router";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { POST } from "@/state/server";
import { canBe } from "@/admin/admin";
import { Spinner } from "@/helpers/Spinner";
import { Pantallas } from "./pantallas";

export function AdminHeader() {
  const { admin } = useAdminContext();
  const router = useRouter();
  // Abajo de 768px bootstrap esconde .navbar-collapse.collapse: sin esto el
  // header no se ve en el celular.
  const [abierto, setAbierto] = useState(false);

  return (
    // navbar-fixed-top aporta left:0/right:0, que con position:sticky pasan a
    // ser restricciones de sticky horizontal y dejan el header clavado cuando
    // una tabla ancha hace scrollear la pagina de costado.
    <div
      className="navbar navbar-inverse navbar-static-top"
      style={{ position: "sticky", top: 0, zIndex: 1030 }}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle"
            onClick={() => setAbierto((a) => !a)}
          >
            <span className="sr-only">Pantallas</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <span className="navbar-brand">
            <img
              src={sitioConfig.logo}
              width="163"
              style={{ marginTop: -20 }}
            ></img>
          </span>
        </div>
        <div className={`navbar-collapse collapse${abierto ? " in" : ""}`}>
          <ul className="nav navbar-nav">
            <li>
              <span className="navbar-brand">
                <Spinner />
              </span>
              {Pantallas.filter((p) => canBe(admin, p.permisos)).map((p) => (
                <Fragment key={p.url}>
                  <Link
                    to={`/admin${p.url}`}
                    className="navbar-brand"
                    id={p.url.replace(/\//g, "_")}
                    onClick={() => setAbierto(false)}
                  >
                    <FontAwesomeIcon icon={p.icon} />
                  </Link>
                  <Tooltip
                    anchorSelect={`#${p.url.replace(/\//g, "_")}`}
                    place="top"
                  >
                    {p.titulo}
                  </Tooltip>
                </Fragment>
              ))}
              <span
                className="navbar-brand"
                onClick={() => {
                  setAbierto(false);
                  POST("/admin/logout");
                  router.navigate({ to: "/" });
                }}
              >
                {admin.nombre}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
